import React from "react"
import strings from "../../localization/strings"
import DateRangeSelect from "./DateRangeSelect"
import IconSimpleTimeEditor from "./IconSimpleTimeEditor"
import moment from "moment"
import * as timeHelper from "../../helpers/timeHelper"
import { IconButton } from "material-ui"
import TodayIcon from "../../../assets/icons/today"
import _ from "lodash"
import { IDate } from "../../models"

interface IProps {
    readonly?: boolean
    dayStartTime24Hour?: number
    displayTimerOnNextLine?: boolean
    // these DateTimes are browser local time
    startDateTime: IDate
    endDateTime: IDate
    handleChange(startDateTime: IDate, endDateTime: IDate, isValid: boolean, todayClicked: boolean): void
}
interface IState {
    showDateRangeSelect: boolean
    startDateTime: moment.Moment
    endDateTime: moment.Moment
    isValidDate: boolean
    isValidTime: boolean
}

export default class DateTimeRangeSelect extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            showDateRangeSelect: true,
            startDateTime: moment(props.startDateTime),
            endDateTime: moment(props.endDateTime),
            isValidDate: true,
            isValidTime: true
        }
    }

    handleChange(todayClicked = false) {
        this.setState({
            isValidTime: moment(this.state.startDateTime).isBefore(this.state.endDateTime),
            showDateRangeSelect: true
        }, () =>
            this.props.handleChange(this.state.startDateTime, this.state.endDateTime, this.state.isValidDate && this.state.isValidTime, todayClicked)
        )
    }

    render() {
        return (
            <div style={{ display: this.props.displayTimerOnNextLine ? "block" : "flex" }}>
                <div style={{ display: "flex", marginRight: 20 }}>
                    {this.state.showDateRangeSelect &&
                        <DateRangeSelect
                            readonly={this.props.readonly}
                            sameDatesAllowed
                            datePickerWidth={135}
                            startDate={this.state.startDateTime.utc(true).toString()}
                            endDate={this.state.endDateTime.utc(true).toString()}
                            handleChange={(startDate, endDate, isValid) =>
                                this.setState({
                                    isValidDate: isValid,
                                    startDateTime: moment(timeHelper.keepConvertUTCToLocal(startDate)).hour(this.state.startDateTime.hour()).minute(this.state.startDateTime.minute()),
                                    endDateTime: moment(timeHelper.keepConvertUTCToLocal(endDate)).hour(this.state.endDateTime.hour()).minute(this.state.endDateTime.minute()),
                                }, () =>
                                    this.handleChange()
                                )
                            }
                        />
                    }
                    <IconButton
                        data-intercom-target="AddEditPunches-Btn-Today"
                        tooltip={strings.Today}
                        iconStyle={{ width: 22, height: 22 }}
                        style={{ padding: 0, top: 25, height: 40 }}
                        onTouchTap={() => {
                            const current = moment()
                            const dayStartTime24Hour = this.props.dayStartTime24Hour || 0
                            let startDateTime = _.cloneDeep(current).startOf("day").add(dayStartTime24Hour, "hour")
                            let endDateTime = _.cloneDeep(current).endOf("day").add(dayStartTime24Hour, "hour")
                            if (current.isBefore(startDateTime)) {
                                startDateTime = startDateTime.add(-1, "day")
                                endDateTime = endDateTime.add(-1, "day")
                            }
                            this.setState({ startDateTime, endDateTime, showDateRangeSelect: false }, () =>
                                this.handleChange(true)
                            )
                        }}
                        disabled={this.props.readonly}
                    >
                        <TodayIcon width={22} height={22} />
                    </IconButton>
                </div>
                <div style={{ display: "flex" }}>
                    <IconSimpleTimeEditor
                        readonly={this.props.readonly}
                        label={strings.Start_Time}
                        simpleTime={{ Hour: this.state.startDateTime.hour(), Minute: this.state.startDateTime.minute() }}
                        handleChange={startTime =>
                            this.setState({ startDateTime: moment(this.state.startDateTime).hour(startTime.Hour).minute(startTime.Minute) }, () =>
                                this.handleChange()
                            )
                        }
                    />
                    <IconSimpleTimeEditor
                        readonly={this.props.readonly}
                        style={{ marginLeft: 20, width: 120 }}
                        label={strings.End_Time}
                        simpleTime={{ Hour: this.state.endDateTime.hour(), Minute: this.state.endDateTime.minute() }}
                        error={this.state.isValidDate && !this.state.isValidTime && strings.Invalid_time_range}
                        handleChange={endTime =>
                            this.setState({ endDateTime: moment(this.state.endDateTime).hour(endTime.Hour).minute(endTime.Minute) }, () =>
                                this.handleChange()
                            )
                        }
                    />
                </div>
            </div>
        )
    }
}